module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAATCAYAAACORR0GAAAACXBIWXMAAAsSAAALEgHS3X78AAAAY0lEQVQ4EWNkYGBgWOrG2sBAW/CABWp8vZYhB01s+vb5H8ODO78OwCxi0DKgjUWvX/wBWcTAhCFDIzBq0ahFoxaNWoQJRi0iG8CriWsXftDEAlB9BAIwixqvnaeNRWDAwPAAANGmGScIFKCDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-yellow-b-1.png
// module id = 244
// module chunks = 0